import clsx from 'clsx'
import React from 'react'

// !w-[92%] !mx-auto !mt-4 !w-[89%]

export const Image = ({ data }: { data: any }) => {
  console.log(data.version)

  return (
    <div
      className={clsx(
        'w-screen max-w-[440px] -ml-5  [&+p]:mt-8',
        {
          'mt-[52px]': data.hasTopGap,
          '-mb-[78px] [&+p]:!mt-0': data.hasBottomGap,
          '!mt-2': data?.classes === 'small',
          'mb-6 !mt-10 px-12': data.version === 'alternative',
        },
        data?.classes,
      )}
    >
      <img
        className="w-full"
        src={data.src}
        width={data.width}
        height={data.height}
        alt={data.alt}
      />
    </div>
  )
}
